import React from 'react';
import { IconProps } from '.';

const SvgSearch = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M16.239 17.3a9.213 9.213 0 0 1-5.989 2.2 9.25 9.25 0 1 1 7.05-3.261l5.73 5.73-1.06 1.061-5.731-5.73ZM18 10.25a7.75 7.75 0 1 1-15.5 0 7.75 7.75 0 0 1 15.5 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgSearch;
